import { Box, Button, Stack, Typography } from '@mui/material'
import React, { FC, useCallback, useEffect, useState } from 'react'
import { LicenseState } from '../LicenseState/LicenseState'
import { LicenseStates } from '../LicenseState/types'
import { useStore } from 'effector-react'
import { $license, getLicenseFx } from '../../store/getLicense'
import moment from 'moment'
import WidgetLoading from '../../../../../components/UI/Loaders/WidgetLoading'
import api from '../../../../../Auth/api'

export const LicensedBlock: FC = () => {
  const license = useStore($license)

  const [state, setState] = useState<LicenseStates>()

  const resetLicenseQuery = useCallback(() => {
    api.post('license/reset').then(() => getLicenseFx())
  }, [])

  useEffect(() => {
    if (!license.licenseIsValid) {
      return setState(LicenseStates.INVALID)
    }
    if (license.key?.validUntil) {
      if (moment(license.key.validUntil).isBefore(new Date())) {
        return setState(LicenseStates.EXPIRED)
      }
    }

    setState(LicenseStates.ACTIVE)
  }, [license])

  if (!state) {
    ;<WidgetLoading />
  }

  return (
    <Stack spacing={1} mt={1} maxWidth={600}>
      <Box>
        <Stack direction={'row'} spacing={0.6}>
          <Typography>Приложение</Typography>
          <Typography sx={{ color: 'green' }}>активировано</Typography>
        </Stack>
        <Typography>Вы пользуетесь легальной версией приложения.</Typography>
      </Box>
      <Typography>Версия приложения: {license.version}</Typography>

      <Stack sx={{ width: 'fit-content' }} spacing={1} alignItems={'center'}>
        <Box>
          <Typography fontWeight={'bold'}>
            Лицензионный ключ: {license.key.value}
          </Typography>
          <LicenseState state={state as LicenseStates} />
        </Box>
        <Button variant="contained" onClick={resetLicenseQuery}>
          Сбросить
        </Button>
      </Stack>
    </Stack>
  )
}
